/**
 * #3 EPOS demo request — /epos-systems and /epos-systems/register.
 */
import { company, email, firstName, lastName, locations, message, phone, replyFooter } from "./common";

const opt = (label) => ({ value: label, label });

const eposDemo = {
  id: "epos_demo",
  label: "EPOS demo request",
  crm: { layout: "Standard", leadSource: "Website Contact Form", tags: ["EPOS demo"] },
  fields: [
    [firstName, lastName],
    [email, phone],
    company,
    locations,
    {
      name: "current_epos", type: "text", label: "Current till / EPOS and card provider",
      placeholder: "e.g. Square, Lightspeed, paper till", crm: "Current_Supplier",
    },
    {
      name: "tier", type: "radio", label: "Which Register version interests you?",
      options: ["Lite", "Core", "Plus", "Not sure yet"].map(opt),
    },
    { ...message, label: "Anything else?", placeholder: "Tell us about your business and how you take payments..." },
  ],
  submitLabel: "Book my demo",
  footer: replyFooter,
  consent: { variant: "standard" },
  success: {
    title: "Demo request received",
    body: "We'll be in touch shortly to arrange your free Register demo.",
  },
  contextToCrm: () => ({ Needs: ["EPOS"] }),
  summary: (values) => (values.tier && values.tier !== "Not sure yet" ? `EPOS demo: Register ${values.tier}` : "EPOS demo request"),
};

export default eposDemo;
